var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.items,"loading":_vm.isFetching,"error-messages":_vm.errorMessages,"label":_vm.label,"autofocus":_vm.autofocus,"no-data-text":"Cargando Bancos...","name":"banco","hide-no-data":""},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }